import { ChangeDetectorRef, Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { NgxLangService } from '@app/@core/utils/ngx-lang.service';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { tap } from 'rxjs/operators';

@Directive({
    selector: '[ngxLangReady]',
    standalone: false
})
export class LangReadyDirective extends OnDestroyMixin implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private changeDetectorRef: ChangeDetectorRef,
    private ngxLang: NgxLangService
  ) {
    super();
  }

  ngOnInit() {
    this.ngxLang
      .ready()
      .pipe(
        tap(() => {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.changeDetectorRef.markForCheck();
        }),
        untilComponentDestroyed(this)
      )
      .subscribe();
  }
}
